import { FullscreenToggle } from "./components/FullscreenToggle";
import { NotificationBell } from "@/modules/notifications/components/NotificationBell";
import { HeaderSettingsMenu } from "./components/HeaderSettingsMenu";
import { UserMenu } from "./components/UserMenu";
import { WorkContextSelector } from "./components/WorkContextSelector";
import { SearchBar } from "@/modules/search";
import { SearchMobileButton } from "@/modules/search/components/SearchMobileButton";
import { SidebarToggle } from "@/modules/main-sidebar/components/SidebarToggle";

export function Header() {
  return (
    // Bandeau clair pleine largeur (vert profond en mode sombre), lueur lime sur la droite.
    <header className="dashboard-header sticky top-0 z-30 shrink-0">
      {/* Pleine largeur, collé au menu latéral : marges alignées sur celles du contenu. */}
      <div className="header-ribbon relative isolate flex items-center gap-2 px-3 py-3 sm:gap-3 sm:px-5 md:px-6 lg:px-8">
        {/* Sur mobile le menu est masqué : on garde ici le bouton pour l'ouvrir. Sur desktop, il est dans le menu. */}
        <SidebarToggle variant="header" className="lg:hidden" />

        <SearchMobileButton />

        <div className="hidden min-w-[14rem] flex-1 md:flex">
          <SearchBar className="w-full max-w-xl" />
        </div>

        <div className="ml-auto flex shrink-0 items-center gap-1.5 sm:gap-3">
          <WorkContextSelector />
          {/* Notifications de l'application : plaintes et requêtes, réponses des Admin. */}
          <NotificationBell />
          <div className="hidden sm:contents">
            <FullscreenToggle />
          </div>
          <div className="hidden sm:contents">
            <HeaderSettingsMenu />
          </div>
          <UserMenu />
        </div>
      </div>
    </header>
  );
}
